define('drops/runtimeQueryBuilder/runtimeQueryBuilder',[
    'jquery',
    'underscore',
    'lq',
    'lq/cssutil',
    'lq/drop'
], function ($, _, lq, cssutil, Drop) {
    'use strict';

    var QueryBuilder = null;
    var builderData = null;

    var RuntimeQueryBuilder = function (options) {
        Drop.call(this, $('<div>'), options);
    };

    Drop.extend(RuntimeQueryBuilder, Drop);

    RuntimeQueryBuilder.typeName = 'RuntimeQueryBuilder';

    RuntimeQueryBuilder.prototype.preRender = function () {
        this.applyPosition();
    };

    RuntimeQueryBuilder.prototype.postRender = function () {
        if (this.data.showEmptyQueryOnPageLoad) {
            this.setValue({
                value: "{}"
            });
        }
    };

    RuntimeQueryBuilder.prototype.getValue = function () {
        return this.lastDesignState;
    };

    RuntimeQueryBuilder.prototype.clearValue = $.noop;

    RuntimeQueryBuilder.prototype.setValue = function (update) {
        var designData = update.value;

        if (QueryBuilder) {
            this.showQueryBuilder(designData);
        } else {
            cssutil.loadCss(require.toUrl(lq.getFrontEndUrl('runtimeQueryBuilder.bundle.css')));

            var self = this;
            require([
                lq.getFrontEndUrl('vendor.bundle.js')
            ], function () {
                require([
                    lq.getFrontEndUrl('runtimeQueryBuilder.bundle.js')
                ], function (Module) {
                    QueryBuilder = Module;

                    $.get(lq.getTenantUrl('Query/BuilderData'),
                        function (data) {
                            builderData = data;
                            self.showQueryBuilder(designData);
                        });
                });
            });
        }
    };

    RuntimeQueryBuilder.prototype.showQueryBuilder = function (designState) {
        this.lastDesignState = designState;

        var self = this;
        QueryBuilder.default({
            baseUrl: lq.getBaseUrl(''),
            tenant: lq.getTenantName(),
            application: lq.getTenantApplicationName(),
            state: designState ? JSON.parse(designState) : {},
            componentName: lq.getNameOfComponent(),
            ravenLogger: lq.getRavenLogger(),
            frontEndUrl: lq.getFrontEndUrl(''),
            tenantUrl: lq.getTenantUrl(''),
            entities: builderData.entities,
            externalData: {
                availableQueries: []
            },
            save: function (query, designData) {
                self.lastDesignState = JSON.stringify(designData);
                self.triggerEventIfEnabled('saveClicked');
            },
            cancel: function () {
                self.triggerEventIfEnabled('cancelClicked');
            }
        }, this.$element.get(0));
    };

    return RuntimeQueryBuilder;
});
